<div class="selector-wrapper">

  <div
    class="selector-content"
    [ngClass]="{'disabled': disabled || showLoader, 'has-error': isIncorrectValue}"
    (click)="openSelectorModal()"
  >

    <ion-item class="selector-item" [lines]="lines">
      <div
        class="select-result-text"
        [ngClass]="{ 'placeholder': !selectedTextValue, 'multiple-results': multiple }"
      >
        {{ (selectedTextValue || placeholder) | translate }}
      </div>

      <div class="select-result-icon" slot="end">
        @if (showLoader) {
          <ion-spinner slot="end" name="circular"></ion-spinner>

        } @else {
          <yu-icon name="caret-down"></yu-icon>
        }
      </div>
    </ion-item>

    <div class="label">{{ label }}</div>

  </div>

  <ng-content select="[extra-button]"></ng-content>

</div>

@if (isIncorrectValue) {
  <yu-helper color="error" icon="warning-circle">{{ helperText }}</yu-helper>
}
